import { render } from "./FileExplorer.vue?vue&type=template&id=20f52c71&scoped=true"
import script from "./FileExplorer.vue?vue&type=script&lang=js"
export * from "./FileExplorer.vue?vue&type=script&lang=js"

import "./FileExplorer.vue?vue&type=style&index=0&id=20f52c71&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f52c71"]])

export default __exports__